import { useRef } from 'react'

export const useDebounce = <T extends (...args: any[]) => any>(
    func: T,
    wait = 500,
    immediate = false
) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    return (...args: Parameters<T>) => {
        const later = () => {
            timeoutRef.current = null
            if (!immediate) {
                func(...args)
            }
        }

        const callNow = immediate && timeoutRef.current === null

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(later, wait)

        if (callNow) {
            func(...args)
        }
    }
}
